import React, { useState } from "react";
import { Container, Button, Typography, Box, TextField } from "@mui/material";
import { renewSubscription } from "../api"; // Importa a função do arquivo api.js
import safeLogger from "../utils/safeLogger";

const RenewSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("email") || "");

  const handleRenew = async () => {
    setLoading(true);
    setError("");

    try {
      safeLogger.info("E-mail usado para renovação:", safeLogger.mask({ email }));

      if (!email) {
        setError("Informe seu e-mail para continuar a renovação.");
        setLoading(false);
        return;
      }

      // Persiste o e-mail no localStorage para uso futuro
      localStorage.setItem("email", email);

      const response = await renewSubscription(email); // Chamada da API
      safeLogger.info("Resposta da API:", safeLogger.mask(response.data));
      // Backend may return sandbox_init_point (dev) or init_point (prod).
      const data = response.data || {};
      const isDev = process.env.NODE_ENV === "development";
      const url = isDev
        ? data.sandbox_init_point || data.init_point || data.redirectUrl
        : data.init_point || data.sandbox_init_point || data.redirectUrl;

      if (url) {
        setRedirectUrl(url);
      } else {
        setError("Resposta inesperada do servidor: link de pagamento não disponível.");
      }
    } catch (error) {
        safeLogger.error("Erro na requisição:", error.message);
      setError(error.response?.data?.error || "Erro ao processar renovação.");
    } finally {
      setLoading(false);
    }
  };

  // Redireciona o usuário para o link de pagamento
  if (redirectUrl) {
    window.location.href = redirectUrl;
    return null;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Renovar Assinatura
      </Typography>
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
      <Box sx={{ mt: 2 }}>
        <TextField
          label="E-mail"
          variant="outlined"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleRenew}
          disabled={loading}
        >
          {loading ? "Processando..." : "Renovar Assinatura"}
        </Button>
      </Box>
    </Container>
  );
};

export default RenewSubscription;
